import {
  timeOfDayDictionary,
  timeOfDaySchema,
} from "@medoma/models/activities";
import type { IText } from "@medoma/components/Text/Text";
import { Text } from "@medoma/components/Text/Text";
import styles from "./TimeSpan.module.scss";
import { formattedTime } from "./timeUtils";
import { useLingui } from "@lingui/react/macro";

type TextProps = Pick<IText, "color" | "size" | "weight">;

type ITimeSpan = {
  timespan: { start: Date; end: Date } | typeof timeOfDaySchema.enum.Any;
};

type TimeSpanProps = ITimeSpan & TextProps;

export const TimeSpan = ({
  timespan,
  color,
  size = "small",
  weight,
}: TimeSpanProps) => {
  const { t } = useLingui();

  if (timespan === timeOfDaySchema.enum.Any) {
    return (
      <time className={styles.timespan}>
        <Text element="span" size={size} weight={weight} color={color}>
          {t(timeOfDayDictionary.Any.short)}
        </Text>
      </time>
    );
  }

  const { start, end } = timespan;

  return (
    <time className={styles.timespan}>
      <Text element="span" size={size} weight={weight} color={color}>
        {formattedTime(start)}
      </Text>
      <Text element="span" size={size} weight={weight} color={color}>
        -
      </Text>
      <Text element="span" size={size} weight={weight} color={color}>
        {formattedTime(end)}
      </Text>
    </time>
  );
};
